import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRespondent, submitGMA } from 'ducks/respondent'
import { WaveContainer } from 'components/quiz/WaveContainer/WaveContainer'
import AbilityQuestion from './AbilityQuestion/AbilityQuestion'
import AbilityBar from './AbilityBar/AbilityBar'
import AbilityResults from './AbilityResults/AbilityResults'
import ConfirmFinish from './ConfirmFinish/ConfirmFinish'
import { t } from 'ttag'
import styles from '../../personality/PersonalityQuestionPage/PersonalityQuestionPage.module.scss'

type Respondent = {
  gma?: any
  status?: string
  name?: string
  loading?: boolean
}

const AbilityQuestionPage = () => {
  const { gma, status, name, loading }: Respondent = useSelector(getRespondent)
  const dispatch = useDispatch()

  if (loading) {
    return null
  }

  if (!status && !name) {
    return (
      <WaveContainer rollUp>
        <div className={styles.noUserContainer}>
          <div className={styles.noUserMessage}>
            <div>{t`Current respondent does not exist`}.</div>
            <div className={styles.contactMessage}>
              {t`Please email us at post@ebber.com if you can't find what you're looking for`}
              .
            </div>
          </div>
        </div>
      </WaveContainer>
    )
  }

  if (gma.status === 'fetching') {
    return null
  }

  if (gma.status === 'completed') {
    return (
      <WaveContainer rollUp>
        <AbilityResults />
      </WaveContainer>
    )
  }

  return (
    <WaveContainer
      showFinishButton
      finishButtonLabel={t`Finish`}
      handleExit={() => dispatch(submitGMA())}
      rollUp
    >
      {gma.status === 'confirmsubmit' && <ConfirmFinish />}
      <AbilityQuestion />
      <AbilityBar />
    </WaveContainer>
  )
}

export default AbilityQuestionPage
